import * as moment from "moment";

/**
 * Date utility
 */
export abstract class DateUtil {


  /**
   * Takes in a Date (in local time zone) and formats it to an UTC ISO date string.
   * Please use this if you need to save any date values in formatDatesOnSave
   * @param date Date object (in local time zone)
   * @returns An ISO string or an null
   */
  public static dateToUtcString(date: Date): string {
    if (!date) {
      return null;
    }
    try {
      const mo = moment.utc(date);
      if (mo) {
        return mo.toISOString(false);
      }
    }
    catch (e) {
      console.warn("Couldn't convert to UTC date string: " + date);
    }
    return null;
  }

  /**
   * Takes in an ISO string in UTC and formats it into a Date (in local time zone).
   * Please use this if you need to load any date values in parseDatesOnLoad
   * @param date Date object (in local time zone)
   * @returns An ISO string or an null
   */
  public static getDate(value: string): Date {
    if (!value) {
      return null;
    }
    try {
      const mo = moment.utc(value);
      if (mo) {
        return mo.toDate();
      }
    } catch (e) {
      console.warn("Couldn't parse a UTC date from: " + value);
    }
    return null;
  }
}
